import React from 'react';
import { Link } from 'react-router-dom';
import { FaInstagram, FaTiktok, FaWhatsapp, FaFacebook } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          {/* Logo & Tagline */}
          <div className="footer-brand">
            <Link to="/" className="logo">
              <img src="/logo-white.png" alt="Weon" className="footer-logo-img" />
            </Link>
            <p className="tagline">החזון שלך | הידע שלנו | הכוח של AI</p>
            <div className="social-links">
              <a href="https://www.instagram.com/aiweon_?igsh=MTN2N3E2NjJwNzJxbQ%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Instagram">
                <FaInstagram />
              </a>
              <a href="https://www.tiktok.com/@aiweon?_r=1&_t=ZS-92iCRpdDXsL" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="TikTok">
                <FaTiktok />
              </a>
              <a href="https://wa.me/972522398911?text=%D7%A0%D7%A9%D7%9E%D7%97%20%D7%9C%D7%A7%D7%91%D7%9C%20%D7%A4%D7%A8%D7%98%D7%99%D7%9D%20%D7%A0%D7%95%D7%A1%D7%A4%D7%99%D7%9D%20%D7%A2%D7%9C%20%D7%90%D7%A4%D7%A9%D7%A8%D7%95%D7%AA%20%D7%9C%D7%A9%D7%99%D7%AA%D7%95%D7%A3%20%D7%A4%D7%A2%D7%95%D7%9C%D7%94%20%D7%91%D7%AA%D7%97%D7%95%D7%9D%20%D7%94%D7%9E%D7%A9%D7%A4%D7%99%D7%A2%D7%A0%D7%99%D7%9D." target="_blank" rel="noopener noreferrer" className="social-link" aria-label="WhatsApp">
                <FaWhatsapp />
              </a>
              <a href="https://www.facebook.com/profile.php?id=61587479324161" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Facebook">
                <FaFacebook />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-links">
            <h4>קישורים מהירים</h4>
            <ul>
              <li><Link to="/">עמוד הבית</Link></li>
              <li><Link to="/campaigns">קמפיינים</Link></li>
              <li><Link to="/about">אודות</Link></li>
              <li><Link to="/contact">צור קשר</Link></li>
            </ul>
          </div>

          {/* For Creators */}
          <div className="footer-links">
            <h4>ליוצרי תוכן</h4>
            <ul>
              <li><Link to="/register">הרשמה לפלטפורמה</Link></li>
              <li><Link to="/campaigns">צפה בקמפיינים</Link></li>
              <li><Link to="/login">התחברות</Link></li>
            </ul>
          </div>

          {/* For Brands */}
          <div className="footer-links">
            <h4>למותגים</h4>
            <ul>
              <li><Link to="/register">הרשמה כמותג</Link></li>
              <li><Link to="/contact">צור קשר</Link></li>
              <li><Link to="/about">למה Weon?</Link></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© {currentYear} AIweon. כל הזכויות שמורות.</p>
          <div className="footer-legal">
            <Link to="/terms">תנאי שימוש</Link>
            <Link to="/privacy">מדיניות פרטיות</Link>
            <Link to="/accessibility">הצהרת נגישות</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
